export default __webpack_public_path__ + "static/media/6.7b36f2da.jpg";